import React from 'react'
import { Tag } from '@hose/eui'
import { TagProps } from '@hose/eui/es/components/tag'
import classNames from 'classnames'
import './index.less'

interface IconTagProps extends Partial<TagProps> {
  text: React.ReactNode | string
  src?: string
  className?: string
}

export default function IconTag({ text, src, className, ...otherTagProps }: IconTagProps) {
  return (
    <Tag size='small' fill="outline" className={classNames('icon-tag-wrapper', className)} {...otherTagProps}>
      {src && <img className="img-icon" alt="" width={16} height={16} src={src}/>}
      <span>{text}</span>
    </Tag>
  )
}
